export default __webpack_public_path__ + "static/media/ELECTRICAL SIMULATOR.81dfb675.jpg";